import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectDestructuringEmpty from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["className"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
var __jsx = React.createElement;
import * as React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { cn } from "@/common/lib/utils";
function Drawer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Root, _extends({
    "data-slot": "drawer"
  }, props));
}
function DrawerTrigger(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Trigger, _extends({
    "data-slot": "drawer-trigger"
  }, props));
}
function DrawerPortal(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Portal, _extends({
    "data-slot": "drawer-portal"
  }, props));
}
function DrawerClose(_ref4) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Close, _extends({
    "data-slot": "drawer-close"
  }, props));
}
function DrawerOverlay(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Overlay, _extends({
    "data-slot": "drawer-overlay",
    className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 !z-[500000] bg-[rgba(0,0,0,0.5)]", className)
  }, props));
}
function DrawerContent(_ref6) {
  var className = _ref6.className,
    children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/React.createElement(DrawerPortal, {
    "data-slot": "drawer-portal"
  }, /*#__PURE__*/React.createElement(DrawerOverlay, null), /*#__PURE__*/React.createElement(DrawerPrimitive.Content, _extends({
    "data-slot": "drawer-content",
    className: cn("group/drawer-content bg-background fixed z-50 flex h-auto flex-col", "data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=top]:max-h-[80vh] data-[vaul-drawer-direction=top]:rounded-b-lg data-[vaul-drawer-direction=top]:border-b", "data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=bottom]:max-h-[80vh] data-[vaul-drawer-direction=bottom]:rounded-t-lg data-[vaul-drawer-direction=bottom]:border-t", "data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0 data-[vaul-drawer-direction=right]:w-3/4 data-[vaul-drawer-direction=right]:border-l data-[vaul-drawer-direction=right]:sm:max-w-sm", "data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0 data-[vaul-drawer-direction=left]:w-3/4 data-[vaul-drawer-direction=left]:border-r data-[vaul-drawer-direction=left]:sm:max-w-sm", className)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "bg-muted mx-auto hidden w-[100px] shrink-0 rounded-full group-data-[vaul-drawer-direction=bottom]/drawer-content:block"
  }), children));
}
function DrawerHeader(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded3);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-slot": "drawer-header",
    className: cn("flex flex-col gap-0.5 p-4 group-data-[vaul-drawer-direction=bottom]/drawer-content:text-center group-data-[vaul-drawer-direction=top]/drawer-content:text-center md:gap-1.5 md:text-left", className)
  }, props));
}
function DrawerFooter(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded4);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-slot": "drawer-footer",
    className: cn("mt-auto flex flex-col gap-2 p-4", className)
  }, props));
}
function DrawerTitle(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded5);
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Title, _extends({
    "data-slot": "drawer-title",
    className: cn("text-foreground font-semibold", className)
  }, props));
}
function DrawerDescription(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded6);
  return /*#__PURE__*/React.createElement(DrawerPrimitive.Description, _extends({
    "data-slot": "drawer-description",
    className: cn("text-muted-foreground text-sm", className)
  }, props));
}
export { Drawer, DrawerPortal, DrawerOverlay, DrawerTrigger, DrawerClose, DrawerContent, DrawerHeader, DrawerFooter, DrawerTitle, DrawerDescription };